export const deliveriesConfig = {
    secondForUpdate: 1000 * 60,
	pageCount: 50,
};
